// extracted by mini-css-extract-plugin
export default {"container":"CallCenterAllTickets_container__X-Jb8","subtitle":"CallCenterAllTickets_subtitle__v+axw"};